import { UserBuilder } from '../../common/users/user-builder';
import { SavedReplyStatus } from './saved-reply-status.enum';
var SavedReplyBuilder = /** @class */ (function () {
    function SavedReplyBuilder() {
        this.savedReply = {
            id: '2022020b-2020-2020-2020-202202202202',
            title: 'Some saved reply',
            content: 'Hi deear user sdjkfhjdsfjkdshfjd',
            locale: 'en',
            shared: false,
            primaryLocale: 'en',
            status: SavedReplyStatus.DRAFT,
            author: new UserBuilder().build(),
            creationDate: Date.now() - 234324234,
            lastUpdateDate: Date.now(),
            recentTasks: [],
            shortcut: ''
        };
    }
    SavedReplyBuilder.prototype.withId = function (id) {
        this.savedReply.id = id;
        return this;
    };
    SavedReplyBuilder.prototype.withTitle = function (title) {
        this.savedReply.title = title;
        return this;
    };
    SavedReplyBuilder.prototype.withContent = function (content) {
        this.savedReply.content = content;
        return this;
    };
    SavedReplyBuilder.prototype.withLocale = function (locale) {
        this.savedReply.locale = locale;
        return this;
    };
    SavedReplyBuilder.prototype.withPrimaryLocale = function (primaryLocale) {
        this.savedReply.primaryLocale = primaryLocale;
        return this;
    };
    SavedReplyBuilder.prototype.withShortcut = function (shortcut) {
        this.savedReply.shortcut = shortcut;
        return this;
    };
    SavedReplyBuilder.prototype.withStatus = function (status) {
        this.savedReply.status = status;
        return this;
    };
    SavedReplyBuilder.prototype.withAuthor = function (author) {
        this.savedReply.author = author;
        return this;
    };
    SavedReplyBuilder.prototype.withCreationDate = function (creationDate) {
        this.savedReply.creationDate = creationDate;
        return this;
    };
    SavedReplyBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.savedReply.lastUpdateDate = lastUpdateDate;
        return this;
    };
    SavedReplyBuilder.prototype.withRecentTasks = function (recentTasks) {
        this.savedReply.recentTasks = recentTasks;
        return this;
    };
    SavedReplyBuilder.prototype.withLastOpenTask = function (lastOpenTask) {
        this.savedReply.lastOpenTask = lastOpenTask;
        return this;
    };
    SavedReplyBuilder.prototype.build = function () {
        return this.savedReply;
    };
    return SavedReplyBuilder;
}());
export { SavedReplyBuilder };
//# sourceMappingURL=saved-reply.builder.js.map